import { render, staticRenderFns } from "./AudioQuestion.vue?vue&type=template&id=ea2124e0&scoped=true"
import script from "./AudioQuestion.vue?vue&type=script&lang=js"
export * from "./AudioQuestion.vue?vue&type=script&lang=js"
import style0 from "./AudioQuestion.vue?vue&type=style&index=0&id=ea2124e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2124e0",
  null
  
)

export default component.exports